import React from 'react';
import { Stack, Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import ImageContainer from './ImageContainer';
import GenerativeItemDetails from './GenerativeItemDetails';
import { useTheme } from '@mui/system';
import { useApiContext } from '../../Hooks/useApiContext';

function EnhancedItemInfo({ item, hospitalId = null }) {
    const theme = useTheme();

    const { userType } = useApiContext();
    let user = JSON.parse(localStorage.getItem(userType));

    const imagesOnly = item.images?.length > 0 &&
    <Stack p={2} spacing={2} backgroundColor={theme.palette.background.white} borderRadius={1}>
        { item.images?.length > 0 && 
            <ImageContainer images={item.images} />
        }
    </Stack>

    if (userType !== 'dashboardUser' && !user.hospital.configurations['AI Features']) {
        return imagesOnly; // physician or staff review users without AI features enabled should not see this section
    }
    if (userType === 'dashboardUser' && hospitalId) {
        // find hospitalId in user.hospitals, then check the configurations same as above
        const hospital = user.hospitals.find(h => h.id === hospitalId);
        if (!hospital || !hospital.configurations['AI Features']) {
            return imagesOnly; // Dashboard users without AI features enabled for the specific hospital should not see this section
        }
    }

    return (
        <Stack p={2} spacing={2} backgroundColor={theme.palette.background.white} borderRadius={1}>
            <Stack direction='row' spacing={1} alignItems='center'>
                <AutoAwesome style={{ color: `${theme.palette.blue.main}` }} />
                <Typography variant="heavy" sx={{ fontSize: '16px', color: `${theme.palette.blue.main}`, alignItems: 'center', display: 'flex' }}>
                    <strong> Enhanced Item Information </strong>
                </Typography>
            </Stack>
            <Typography variant="normal" sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}` }}>
                The below information has been automatically sourced from publicly available data sources and/or generative AI tools. Help us improve by sharing feedback!
            </Typography>
            { item.images?.length > 0 && 
                <ImageContainer images={item.images}/>
            }
            <GenerativeItemDetails item={item} />
        </Stack>
    );
}

export default EnhancedItemInfo;
